module.exports = __webpack_public_path__ + "static/media/calendar-slash.6cbc3064.svg";